/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { Control } from 'react-hook-form';

type UseFieldControllerContextReturn = {
  name: string;
  inputLabel?: string;
  setInputLabel(value?: string): void;
  maxLength?: number;
  setMaxLength(length?: number): void;
  control?: Control;
};

type FieldControllerProviderProps = {
  children: ReactNode;
  value: Omit<
    UseFieldControllerContextReturn,
    'setInputLabel' | 'setMaxLength'
  >;
};

const FieldControllerContext = createContext<UseFieldControllerContextReturn>({
  name: '',
  setInputLabel() {},
  setMaxLength() {},
});

export const FieldControllerProvider: React.FC<
  FieldControllerProviderProps
> = ({ value: { name, control }, children }) => {
  const [inputLabel, setInputLabel] = useState<string>();
  const [maxLength, setMaxLength] = useState<number>();

  const contextValue = useMemo(
    () => ({
      name,
      control,
      inputLabel,
      setInputLabel,
      maxLength,
      setMaxLength,
    }),
    [name, control, inputLabel, maxLength]
  );

  return (
    <FieldControllerContext.Provider value={contextValue}>
      {children}
    </FieldControllerContext.Provider>
  );
};

export const useFieldControllerContext = () =>
  useContext(FieldControllerContext);
